import { NgModule } from '@angular/core';
import { FcTabGroup } from './tab-group.component';
import { FcTabLabel } from './tab-label.directive';
import { FcTabNav, FcTabLink, FcTabNavPanel } from './tab-nav.component';
import { FcTab } from './tab.component';

@NgModule({
  imports: [FcTabGroup, FcTab, FcTabLabel, FcTabNav, FcTabLink, FcTabNavPanel],
  exports: [FcTabGroup, FcTab, FcTabLabel, FcTabNav, FcTabLink, FcTabNavPanel],
})
export class FcTabsModule {}
